import React, {useContext, useEffect, useRef, useState} from 'react';
import {Button, ButtonVariant} from '../../../components/button';
import {Account} from '../../../models';
import {AccountContext} from '../../../contexts';

interface ElevatorPitchProps {
  account: Account;
}

const ElevatorPitch: React.FC<ElevatorPitchProps> = ({account}) => {
  const {accountService} = useContext(AccountContext);
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPortrait, setIsPortrait] = useState(false);
  const [accountDetails, setAccountDetails] = useState<Account>(account);

  const handlePlayVideo = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  useEffect(() => {
    accountService.getAccount(account.id).then(res => {
      res.data && setAccountDetails(new Account(res.data));
    });
  }, [account]);

  if (!accountDetails?.elevatorPitchResource?.url) {
    return null;
  }

  return (
    <div className="flex flex-row h-full items-center justify-center gap-4">
      <div className="relative flex justify-center h-96">
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="ml-[22px] tracking-widest block whitespace-nowrap uppercase text-gray-400 font-black leading-none text-5xl -rotate-90">
            RECCO REAL
          </span>
        </span>
      </div>
      <div className="relative h-96 min-w-[200px] max-w-md w-full overflow-hidden rounded-lg">
        <video
          ref={videoRef}
          src={accountDetails.elevatorPitchResource.url}
          className={`${isPortrait ? 'object-contain bg-black' : 'object-cover'} absolute inset-0 w-full h-full`}
          muted={!isPlaying}
          controls={isPlaying}
          onLoadedMetadata={e => {
            const v = e.currentTarget;
            if (v.videoWidth && v.videoHeight) {
              setIsPortrait(v.videoHeight > v.videoWidth);
            }
          }}
          onEnded={() => setIsPlaying(false)}
        />
        {!isPlaying && (
          <>
            <div className="absolute inset-0 bg-black/30"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <Button
                variant={ButtonVariant.Primary}
                onClick={handlePlayVideo}
                className="w-16 h-16 !bg-black/60 rounded-full flex items-center justify-center shadow-lg hover:!bg-black/80 transition-colors group">
                <span className="text-white text-2xl ml-1 group-hover:scale-110 transition-transform">▶</span>
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ElevatorPitch;
